export const MOBILE_SM_END = 575.98;
export const MOBILE_LG = 576;
export const MOBILE_LG_END = 767.98;
export const DESKTOP_SM = 768;
export const DESKTOP_SM_END = 991.98;
export const DESKTOP_MD = 992;
export const DESKTOP_MD_END = 1199.98;
export const DESKTOP_LG = 1200;
export const DESKTOP_LG_END = 1399.98;
export const DESKTOP_XL = 1400;

export function isDesktopSm(): boolean {
  const width = window.innerWidth;

  return width >= DESKTOP_SM && width <= DESKTOP_SM_END;
}
